import urlParser from 'bloko/common/urlParser';

type Primitive = number | string | boolean | undefined | null;

export const updateUrl = (url: string, additionalParams: Record<string, Primitive | Primitive[]> = {}): string => {
    const parsedUrl = urlParser(url);
    parsedUrl.params = { ...parsedUrl.params, ...additionalParams };
    return parsedUrl.href;
};
